import "./App.css";
import BestQuotes from "./components/BestQuotes";
import Details from "./components/Details";
import FloorPlan from "./components/FloorPlan";
import Footer from "./components/Footer";
import Form from "./components/Form";
import Header from "./components/Header";
import Hero from "./components/Hero";
import StripSection from "./components/StripSection";
import Pricing from "./components/Pricing";
import AboutDeveloper from "./components/AboutDeveloper";
import NewForm from "./components/NewForm";
import Slider from "./components/Slider";
import { useEffect } from "react";

function App() {
  const project = "Raymond MIG Bandra";

  const galleryImages = [
    {
      src: "images/lntevaraheights-Gallery-Yoga.webp",
      alt: "gallery1",
      title: "gallery1",
    },
    {
      src: "images/lntevaraheights-Gallery-Creche.webp",
      alt: "gallery3",
      title: "gallery3",
    },
    {
      src: "images/lntevaraheights-Gallery-Bedroom.webp",
      alt: "gallery4",
      title: "gallery4",
    },
    {
      src: "images/lntevaraheights-Gallery-Co-Working-Pods.webp",
      alt: "gallery5",
      title: "gallery5",
    },
    // Add more amenities as needed
  ];
  const amenityImages = [
    {
      src: "images/lntevaraheightsindoorgameroom.webp",
      alt: "Indoor game room",
      title: "Indoor game room",
    },
    {
      src: "images/lntevaraheightskidsplayarea.webp",
      alt: "Kids play area",
      title: "Kids play area",
    },
    {
      src: "images/lntevaraheightsgym.webp",
      alt: "Gym",
      title: "Gym",
    },
    // Add more amenities as needed
  ];
  useEffect(() => {
    // Disable right-click
    const handleContextMenu = (e) => e.preventDefault();

    // Disable F12 and Ctrl+Shift+I
    const handleKeyDown = (e) => {
      if (e.key === "F12" || (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "i") || (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "i")) {
        e.preventDefault();
      }
    };

    // Attach event listeners
    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);

    // Cleanup event listeners
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []); // Empty array means it runs once on mount
  return (
    <>
      <div className="App">
        <Header />
        <Hero />
        <StripSection />
        <NewForm />
        <Details project={project} />
        <Pricing project={project} />
        <FloorPlan project={project} />
        <Slider project={project} title="Amenities" images={amenityImages} />
        <Slider project={project} title="Gallery" images={galleryImages} />
        <BestQuotes />
        <AboutDeveloper />
        <Footer />
        <Form />
      </div>
    </>
  );
}

export default App;
